module.exports = __webpack_public_path__ + "img/icon-liulan.f612c6ff.png";